import { Award, Users, Clock, Shield, DollarSign } from "lucide-react";
import fintechNetworkBg from "@/assets/fintech-network-bg.webp";

const About = () => {
  return (
    <section className="py-16 relative overflow-hidden" aria-labelledby="about-heading">
      {/* Fintech Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{backgroundImage: `url(${fintechNetworkBg})`}}
      ></div>
      
      {/* Dark Overlay for Readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/85 via-blue-900/80 to-indigo-900/85"></div>
      
      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="relative container mx-auto px-4">
        <header className="text-center mb-12">
          <h2 id="about-heading" className="text-3xl font-bold mb-4 text-white drop-shadow-lg">
            About Processing Bro's - America's #1 Rated Credit Card Processing Company
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto drop-shadow-md">
            Your trusted partner in merchant services since 2018, helping 10,000+ businesses across America save millions annually on payment processing fees. Specializing in compliant cash discount programs, POS systems, and the lowest credit card processing rates in the industry.
          </p>
        </header>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          <article>
            <h3 className="text-2xl font-semibold mb-4 text-white">Our Merchant Services Mission - Best Rates Guaranteed</h3>
            <p className="text-gray-200 mb-6 leading-relaxed">
              We founded Processing Bro's in 2018 with a simple mission: to provide the best credit card processing rates and merchant services in America. After seeing countless small businesses overpay on payment processing fees, we developed compliant cash discount programs and transparent pricing models that eliminate hidden costs entirely.
            </p>
            <p className="text-gray-200 leading-relaxed">
              Our cash discount program is 100% compliant with Dodd-Frank Act regulations, CFPB guidelines, and all major card network rules. We've helped over 10,000 businesses save millions annually on merchant account fees while providing superior customer service and support.
            </p>
          </article>
          
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/20 text-center hover:bg-white/15 transition-all duration-300">
              <Users className="h-8 w-8 text-blue-300 mx-auto mb-3" />
              <h4 className="font-semibold text-white mb-2">10,000+</h4>
              <p className="text-sm text-gray-200">Happy Merchants</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/20 text-center hover:bg-white/15 transition-all duration-300">
              <DollarSign className="h-8 w-8 text-green-300 mx-auto mb-3" />
              <h4 className="font-semibold text-white mb-2">$50M+</h4>
              <p className="text-sm text-gray-200">Saved in Processing Fees</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/20 text-center hover:bg-white/15 transition-all duration-300">
              <Clock className="h-8 w-8 text-orange-300 mx-auto mb-3" />
              <h4 className="font-semibold text-white mb-2">1-5 Days</h4>
              <p className="text-sm text-gray-200">Average Approval Time</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/20 text-center hover:bg-white/15 transition-all duration-300">
              <Award className="h-8 w-8 text-purple-300 mx-auto mb-3" />
              <h4 className="font-semibold text-white mb-2">A+ Rated</h4>
              <p className="text-sm text-gray-200">BBB Rating</p>
            </div>
          </div>
        </div>

        <aside className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-xl border border-white/20">
          <h3 className="text-2xl font-semibold mb-6 text-center text-white">Why Choose Processing Bro's for Your Payment Processing Needs?</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <Shield className="h-12 w-12 text-blue-300 mx-auto mb-4" />
              <h4 className="font-semibold mb-2 text-white">Fully Compliant Credit Card Processing</h4>
              <p className="text-gray-200 text-sm">
                Our cash discount program follows all Dodd-Frank regulations, CFPB guidelines, and card network rules for legal payment processing.
              </p>
            </div>
            <div className="text-center">
              <Users className="h-12 w-12 text-green-300 mx-auto mb-4" />
              <h4 className="font-semibold mb-2 text-white">Dedicated Merchant Services Support</h4>
              <p className="text-gray-200 text-sm">
                Expert account managers provide ongoing merchant account support, POS system optimization, and payment processing guidance.
              </p>
            </div>
            <div className="text-center">
              <Award className="h-12 w-12 text-purple-300 mx-auto mb-4" />
              <h4 className="font-semibold mb-2 text-white">Proven Processing Fee Savings</h4>
              <p className="text-gray-200 text-sm">
                Average merchant saves $8,000+ annually with our comprehensive credit card processing and cash discount solutions.
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default About;
